<app-banner
    *ngIf="bannerShown"
    text="Your trial expires in {{ daysLeftInTrial | i18nPlural: daysLeftPluralMapping }}. Add your billing details now to start your subscription."
    [buttonTitle]="'Upgrade Trial'"
    [type]="'info'"
    (buttonClicked)="clickUpgradeTrial()"
>
</app-banner>
